<template>
  <div>
    <div class="overflow-auto" v-if="tournamentGame.length > 0">
      <div class="week-tabs">
        <div
          v-for="(day, idx) in weekDates"
          :key="idx"
          class="date-tab"
          @click="selectDate(day.date)"
        >
          <div class="day-name">{{ day.label.split(" ")[0] }}</div>
          <!-- Show the day (e.g., Sun) -->
          <div
            class="day-number"
            :class="{ active: day.date === selectedDate }"
          >
            {{ day.label.split(" ")[1] }}
          </div>
        </div>
      </div>

      <!-- Show games for selected date only -->
      <div v-if="filteredGames && filteredGames.length > 0">
        <div class="row m-0">
          <div
            v-for="gameItem in filteredGames"
            :key="gameItem.id"
            class="col-12 col-md-6 col-xl-4 p-0"
          >
            <div class="game-detail-wrapper single-event-side-game mb-0">
              <div class="game-content">
                <div class="live-inner-top">
                  <div class="d-flex align-items-center" style="gap: 5px">
                    <div
                      class="live-delayed-sec"
                      v-if="
                        gameItem.game_delayed == 1 &&
                          gameItem.game_live == 1 &&
                          gameItem.status == 1
                      "
                    >
                      <span class="delayed-tag">Delayed</span>
                      <div class="video-icon">
                        <img src="../../assets/Svg/delayed.svg" alt="delayed" />
                      </div>
                    </div>
                    <div
                      class="live-delayed-sec"
                      v-if="
                        gameItem.game_delayed == 0 &&
                          gameItem.game_live == 1 &&
                          gameItem.status == 1
                      "
                    >
                      <span class="delayed-tag live-tag">Live</span>
                      <div class="video-icon">
                        <!-- <img src="../../assets/Svg/video.svg" alt="live" /> -->
                      </div>
                    </div>
                    <span class="game-name">{{ gameItem.game_name }}</span>
                  </div>
                  <div class="right-part-sec">
                    <div
                      v-if="
                        gameItem.status == 1 &&
                          gameItem.game_scores &&
                          gameItem.game_scores.length > 0
                      "
                      class="live-count"
                    >
                      {{ gameItem.game_scores[0].end_inning_flag }}
                    </div>
                    <div class="final-count" v-if="gameItem.status == 2">
                      <span>F</span>
                    </div>
                    <div @click.stop="handleActionClick(gameItem)" class="d-flex justify-content-end">
                      <TournamentEllipsis v-if="
                        currentIsAdmin == '1' || gameItem.umpire_id == UserId
                      " :clickedGame="gameItem" :currentIsAdmin="currentIsAdmin" :currentIsUmpire="currentIsUmpire"
                        :association_id="association_id" ref="ellipsisDropdown" />
                    </div>
                  </div>
                </div>
                <div class="date-content">
                  <p>{{ gameItem.start_time }}</p>
                </div>

                <div class="team-opponent-score-wrap">
                  <div>
                    <div class="d-flex align-items-center flex-row">
                      <div
                        class="opponent-name"
                        v-if="
                          gameItem.game_scores?.some(
                            (team) => team.team_type === 1
                          )
                        "
                      >
                        <div
                          class="custom-avatar"
                          v-if="
                            gameItem.game_scores?.find(
                              (team) => team.team_type === 1
                            )?.team.team_avatar == null
                          "
                          :style="{ backgroundColor: getRandomColor() }"
                        >
                          {{
                            getInitials(
                              gameItem.game_scores?.find(
                                (team) => team.team_type === 1
                              )?.team.team_name
                            )
                          }}
                        </div>
                        <div class="team-image" v-else>
                          <div class="users-notification" v-if="imgLoader == 1">
                            <img src="../../assets/loader.gif" alt="" />
                          </div>
                          <img
                            @load="onImageLoad"
                            v-if="
                              gameItem.game_scores?.find(
                                (team) => team.team_type === 1
                              )?.team.team_avatar == null
                            "
                            :src="team_image"
                            alt=""
                          />
                          <img
                            @load="onImageLoad"
                            v-if="
                              gameItem.game_scores?.find(
                                (team) => team.team_type === 1
                              )?.team.team_avatar != null
                            "
                            :src="
                              url +
                                gameItem.game_scores?.find(
                                  (team) => team.team_type === 1
                                )?.team.team_avatar
                            "
                            alt=""
                          />
                        </div>
                        <h6
                          class="teams-name-sec"
                          :class="{
                            'winner-text':
                              gameItem.status === 2 &&
                              gameItem.team2Runs > gameItem.team1Runs,
                            'loser-text':
                              gameItem.status === 2 &&
                              gameItem.team2Runs < gameItem.team1Runs,
                          }"
                        >
                          #{{
                            gameItem.game_scores?.find(
                              (team) => team.team_type === 1
                            )?.teams.team_sr_no
                          }}:
                          {{
                            gameItem.game_scores?.find(
                              (team) => team.team_type === 1
                            )?.team.team_name
                          }}
                        </h6>
                      </div>
                      <div class="opponent-name" v-else>
                        <div
                          class="custom-avatar"
                          v-if="!gameItem.team_one?.team_data?.team_avatar"
                          :style="{ backgroundColor: getRandomColor() }"
                        >
                          {{
                            getInitials(gameItem.team_one?.team_data?.team_name)
                          }}
                        </div>
                        <div class="team-image" v-else>
                          <div class="users-notification" v-if="imgLoader == 1">
                            <!-- <div class="lds-dual-ring-refresh"></div> -->
                            <img src="../../assets/loader.gif" alt="" />
                          </div>
                          <img
                            @load="onImageLoad"
                            v-if="
                              gameItem.team_one &&
                                gameItem.team_one.team_data.team_avatar
                            "
                            :src="url + gameItem.team_one.team_data.team_avatar"
                            alt=""
                          />
                          <img
                            @load="onImageLoad"
                            v-else
                            alt=""
                            :src="team_image"
                          />
                        </div>
                        <div
                          class="teams-name-sec"
                          v-if="
                            gameItem.team_one &&
                              gameItem.team_one.team_data.team_name
                          "
                        >
                          {{
                            `#${gameItem.team_one.team_sr_no}: ${gameItem.team_one.team_data.team_name}`
                          }}
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-items-center flex-row pb-1">
                      <div
                        class="opponent-name"
                        v-if="
                          gameItem.game_scores?.some(
                            (team) => team.team_type === 2
                          )
                        "
                      >
                        <div
                          class="custom-avatar"
                          v-if="
                            gameItem.game_scores?.find(
                              (team) => team.team_type === 2
                            )?.team.team_avatar == null
                          "
                          :style="{ backgroundColor: getRandomColor() }"
                        >
                          {{
                            getInitials(
                              gameItem.game_scores?.find(
                                (team) => team.team_type === 2
                              )?.team.team_name
                            )
                          }}
                        </div>
                        <div class="team-image" v-else>
                          <div class="users-notification" v-if="imgLoader == 1">
                            <img src="../../assets/loader.gif" alt="" />
                          </div>
                          <img
                            @load="onImageLoad"
                            v-if="
                              gameItem.game_scores?.find(
                                (team) => team.team_type === 2
                              )?.team.team_avatar == null
                            "
                            :src="team_image"
                            alt=""
                          />
                          <img
                            @load="onImageLoad"
                            v-if="
                              gameItem.game_scores?.find(
                                (team) => team.team_type === 2
                              )?.team.team_avatar != null
                            "
                            :src="
                              url +
                                gameItem.game_scores?.find(
                                  (team) => team.team_type === 2
                                )?.team.team_avatar
                            "
                            alt=""
                          />
                        </div>
                        <h6
                          class="teams-name-sec"
                          :class="{
                            'winner-text':
                              gameItem.status === 2 &&
                              gameItem.team1Runs > gameItem.team2Runs,
                            'loser-text':
                              gameItem.status === 2 &&
                              gameItem.team1Runs < gameItem.team2Runs,
                          }"
                        >
                          #{{
                            gameItem.game_scores?.find(
                              (team) => team.team_type === 2
                            )?.teams.team_sr_no
                          }}:
                          {{
                            gameItem.game_scores?.find(
                              (team) => team.team_type === 2
                            )?.team.team_name
                          }}
                        </h6>
                      </div>
                      <div class="opponent-name" v-else>
                        <div
                          class="custom-avatar"
                          v-if="!gameItem.team_two?.team_data?.team_avatar"
                          :style="{ backgroundColor: getRandomColor() }"
                        >
                          {{
                            getInitials(gameItem.team_two?.team_data?.team_name)
                          }}
                        </div>
                        <div class="team-image" v-else>
                          <div class="users-notification" v-if="imgLoader == 1">
                            <!-- <div class="lds-dual-ring-refresh"></div> -->
                            <img src="../../assets/loader.gif" alt="" />
                          </div>
                          <img
                            @load="onImageLoad"
                            v-if="
                              gameItem.team_two &&
                                gameItem.team_two.team_data.team_avatar
                            "
                            :src="url + gameItem.team_two.team_data.team_avatar"
                            alt=""
                          />
                          <img
                            @load="onImageLoad"
                            v-else
                            alt=""
                            :src="team_image"
                          />
                        </div>
                        <div
                          class="teams-name-sec"
                          v-if="
                            gameItem.team_two &&
                              gameItem.team_two.team_data.team_name
                          "
                        >
                          {{
                            `#${gameItem.team_two.team_sr_no}: ${gameItem.team_two.team_data.team_name}`
                          }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="played-data text-right">
                    <div>
                      <p
                        class="tie flex-row align-items-start"
                        :class="{
                          'winner-text':
                            gameItem.status === 2 &&
                            gameItem.team2Runs > gameItem.team1Runs,
                          'loser-text':
                            gameItem.status === 2 &&
                            gameItem.team2Runs < gameItem.team1Runs,
                        }"
                        style="gap: 5px; height: 45px;"
                      >
                        {{
                          gameItem.team2Runs === 0 && gameItem.team1Runs === 0
                            ? ""
                            : gameItem.status != 1 &&
                              gameItem.team1Runs !== gameItem.team2Runs
                            ? (gameItem.team2Runs > gameItem.team1Runs
                                ? ""
                                : "") + gameItem.team2Runs
                            : gameItem.team2Runs
                        }}
                        <img
                          :src="arrow_left"
                          class="arrow-image"
                          alt="arrow-left"
                          v-if="
                            gameItem.status === 1 &&
                              gameItem.game_scores &&
                              gameItem.game_scores?.find(
                                (team) =>
                                  team.team_type == 1 && team.batting_flag == 1
                              )
                          "
                        />
                        <img
                          :src="cup"
                          alt="cup"
                          v-if="
                            gameItem.status === 2 &&
                              gameItem.team2Runs > gameItem.team1Runs
                          "
                        />
                      </p>
                      <p
                        class="win-data-two flex-row align-items-center"
                        :class="{
                          'winner-text':
                            gameItem.status === 2 &&
                            gameItem.team1Runs > gameItem.team2Runs,
                          'loser-text':
                            gameItem.status === 2 &&
                            gameItem.team1Runs < gameItem.team2Runs,
                        }"
                        style="gap: 5px"
                      >
                        {{
                          gameItem.team1Runs === 0 && gameItem.team2Runs === 0
                            ? ""
                            : gameItem.status != 1 &&
                              gameItem.team1Runs !== gameItem.team2Runs
                            ? (gameItem.team1Runs > gameItem.team2Runs
                                ? ""
                                : "") + gameItem.team1Runs
                            : gameItem.team1Runs
                        }}
                        <img
                          :src="arrow_left"
                          class="arrow-image"
                          alt="arrow-left"
                          v-if="
                            gameItem.status === 1 &&
                              gameItem.game_scores &&
                              gameItem.game_scores?.find(
                                (team) =>
                                  team.team_type == 2 && team.batting_flag == 1
                              )
                          "
                        />
                        <img
                          :src="cup"
                          alt="cup"
                          v-if="
                            gameItem.status === 2 &&
                              gameItem.team1Runs > gameItem.team2Runs
                          "
                        />
                      </p>
                    </div>

                    <p
                      class="not-started mt-3"
                      style="gap: 5px !important;"
                      v-if="gameItem.game_live == 0 && gameItem.status != 2"
                    >
                      Game yet to begin
                    </p>
                  </div>
                </div>

                <div class="game-location">
                  <p>{{ gameItem.tournament.tournamentName }}</p>
                </div>
                <span
                  class="game-location cursor-pointer"
                  @click="openGoogleMapforGamePark(gameItem, $event)"
                  v-if="
                    gameItem.park_name != null ||
                      gameItem.park_name != '' ||
                      gameItem?.field?.field_name != null ||
                      gameItem?.field?.field_name != ''
                  "
                >
                  <img src="../../assets/Svg/maximize.svg" class="mr-2" />
                  <p>
                    {{ gameItem?.field?.field_name }}
                    <span v-if="gameItem?.field?.field_name">-</span>
                    {{ gameItem?.park?.park_name }}
                  </p>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="no-event-wrap h-100" v-else-if="hasNoGamesForAnyDate">
        <img src="../../assets/Svg/no-data.svg" alt />
        <p class="header">No games scheduled yet.</p>
        <p class="info">
          There are no scheduled games to display for this date.
        </p>
      </div>
      <!-- Show this message when there are games but none for the selected date -->
      <div class="no-event-wrap h-100" v-else>
        <img src="../../assets/Svg/no-data.svg" alt />
        <p class="header">No games scheduled for this date.</p>
        <p class="info">
          There are no games scheduled for the selected date.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import TournamentEllipsis from "./Modals/TournamentTeamActionModal.vue";

export default {
  name: "EventGames",
  components: {
    TournamentEllipsis,
  },
  data() {
    return {
      team_image: require("../../assets/Svg/people.svg"),
      arrow_left: require("../../assets/Svg/arrow-left.svg"),
      cup: require("../../assets/Svg/cup.svg"),
      url: this.$groupAvatarStorageURL,
      imgLoader: 1,
      clickedGame: [],
      UserId: localStorage.getItem("userId"),
      teamEventData: {},
      selectedDate: moment().format("YYYY-MM-DD"),
      
    };
  },
  props: {
    tournamentGame: {
      type: Array,
    },
    showLoader: {
      type: Number,
    },
    currentIsUmpire: {
      type: String,
    },
    currentIsAdmin: {
      type: String,
    },
    association_id: {
      type: Number,
    },
  },
  computed: {
    hasNoGamesForAnyDate() {
      const games = this.tournamentGame || [];
      const userId = this.UserId;

      // Check if event info is available
      const eventEndRaw = games?.[0]?.event?.exactEndDate;
      if (!eventEndRaw) return false;

      const eventEndDate = moment(eventEndRaw, "MMM DD, YYYY");
      const today = moment();

      const isEventOver = eventEndDate.isBefore(today, "day");

      // Check if user has any games assigned
      const userHasGames = games.some((game) => {
        // Adjust based on your structure
        return (
          game.umpire_id == userId || // direct match
          (Array.isArray(game.umpires) && game.umpires.includes(userId))
        );
      });

      if (isEventOver && !userHasGames) {
        this.$root.$emit("hideSchedule");
      }
      // Hide the section if event is over AND user has no games
      return isEventOver && !userHasGames;
    },
    weekDates() {
      // Get start and end dates from the first tournament game's event (assuming all games belong to same event)
      if (!this.tournamentGame || this.tournamentGame.length === 0) {
        return [];
      }

      const startDate = moment(
        this.tournamentGame[0].event.exactStartDate,
        "MMM DD, YYYY"
      );
      const endDate = moment(
        this.tournamentGame[0].event.exactEndDate,
        "MMM DD, YYYY"
      );

      // Calculate difference in days
      const daysDiff = endDate.diff(startDate, "days") + 1; // +1 to include both start and end dates

      // Create array of dates between start and end dates
      const eventDates = Array.from({ length: daysDiff }, (_, i) => {
        const date = startDate.clone().add(i, "days");
        return {
          date: date.format("YYYY-MM-DD"),
          label: date.format("ddd D"),
          isToday: date.isSame(moment(), "day"),
        };
      });

      return eventDates;
    },

    filteredGames() {
      if (!this.tournamentGame || this.tournamentGame.length === 0) {
        return [];
      }

      // Filter games based on the selected date
      return this.tournamentGame.filter((game) => {
        const gameDate = moment(game.start_date).format("YYYY-MM-DD");
        return gameDate === this.selectedDate;
      });
    },

    formatSelectedDate() {
      return moment(this.selectedDate).format("dddd, MMMM D, YYYY");
    },
  },

  watch: {
    // Watch for changes in tournamentGame prop and update filtered games
    tournamentGame: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.setFirstAvailableGameDate();
        }
      },
      immediate: true,
    },
  },

  methods: {
    setFirstAvailableGameDate() {
      if (!this.tournamentGame || this.tournamentGame.length === 0) return;

      const today = moment().format("YYYY-MM-DD");
      const eventStartDate = moment(
        this.tournamentGame[0].event.exactStartDate,
        "MMM DD, YYYY"
      ).format("YYYY-MM-DD");
      const eventEndDate = moment(
        this.tournamentGame[0].event.exactEndDate,
        "MMM DD, YYYY"
      ).format("YYYY-MM-DD");

      // Check if today is within event range
      if (today >= eventStartDate && today <= eventEndDate) {
        // Check if there are games on today's date
        const hasGamesToday = this.tournamentGame.some((game) => {
          const gameDate = moment(game.start_date).format("YYYY-MM-DD");
          return gameDate === today;
        });

        if (hasGamesToday) {
          // If there are games today, select today
          this.selectedDate = today;
          return;
        }
      }

      // If no games today or today is not within event range,
      // find the first date that has games within the event date range
      const gamesWithinEventRange = this.tournamentGame.filter((game) => {
        const gameDate = moment(game.start_date).format("YYYY-MM-DD");
        return gameDate >= eventStartDate && gameDate <= eventEndDate;
      });

      if (gamesWithinEventRange.length > 0) {
        // Sort games by date and select the first one
        const sortedGames = gamesWithinEventRange.sort((a, b) => {
          return moment(a.start_date).diff(moment(b.start_date));
        });

        const firstGameDate = moment(sortedGames[0].start_date).format("YYYY-MM-DD");
        this.selectedDate = firstGameDate;
      } else {
        // Fallback: if no games within event range, select event start date
        this.selectedDate = eventStartDate;
      }
    },
    getInitials(name) {
      return name ? name.charAt(0).toUpperCase() : "?";
    },
    getRandomColor() {
      const colors = [
        "#FCE4EC",
        "#E3F2FD",
        "#F1F8E9",
        "#FFF8E1",
        "#EDE7F6",
        "#FFEBEE",
        "#F9FBE7",
        "#FFF3E0",
        "#ECEFF1",
        "#FFECB3",
      ];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    onImageLoad() {
      this.imgLoader = 0;
    },

    handleActionClick(data) {
      this.clickedGame = data;
    },

    selectDate(date) {
      this.selectedDate = date;
    },
  },
  mounted() {
    console.log(this.tournamentGame, "tour");
    this.$nextTick(() => {
      this.setFirstAvailableGameDate();
    });
  },
};
</script>

<style scoped>
.week-tabs {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  overflow: hidden;
  border-radius: 8px;
  padding: 20px 10px;
  background-color: #ffffff;
  margin-top: 10px;
}

.date-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  font-weight: 400;
  color: #4d4d4d;
  cursor: pointer;
  transition: all 0.3s ease;
}

.date-tab:hover {
  color: #188ef5;
}

.date-tab .day-number {
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  transition: all 0.3s ease;
}

.date-tab .day-number.active {
  background-color: #188ef5;
  color: #fff;
  position: relative;
}

.date-tab .day-number.active::after {
  content: "";
  min-width: 8px;
  max-width: 8px;
  min-height: 8px;
  max-height: 8px;
  background: #e088f9;
  border-radius: 100px;
  position: absolute;
  top: 30px;
}
</style>
